export const TYPES = ['identity_check', 'document_check']
